import { PropTypes } from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { setReadOnly } from '../../redux/actions/formTemplateUIActions';
import LoadingApiPlaceholder from '../presentational/LoadingApiPlaceholder/LoadingApiPlaceholder';
import TemplateVersionInfo from '../presentational/TemplateVersionInfo/TemplateVersionInfo';
import FormTemplateFormContainer from './FormTemplateFormContainer';

export function ViewFormTemplateVersionContainer(props) {
  const { formTemplateVersion, formTemplateRequestLoading, readOnly, setReadOnly, accountTimezone } = props;
  const { templateId } = useParams();

  useEffect(() => {
    if (formTemplateVersion) setReadOnly(true);
    return () => {
      setReadOnly(false);
    };
  }, [formTemplateVersion, setReadOnly]);

  const viewFormTemplateRender = () => {
    if (formTemplateRequestLoading) {
      return <LoadingApiPlaceholder layout="editFormTemplate" />;
    }
    return (
      <>
        <TemplateVersionInfo formTemplate={formTemplateVersion} accountTimezone={accountTimezone} />
        <FormTemplateFormContainer formTemplate={formTemplateVersion} readOnly={readOnly} formId={Number(templateId)} />
      </>
    );
  };

  return <>{viewFormTemplateRender()}</>;
}

const mapStateToProps = (state) => {
  return {
    formTemplateVersion: state.formTemplateReducer.formTemplateVersion,
    formTemplateRequestLoading: state.formTemplateApiReducer.formTemplateRequest.loading,
    readOnly: state.formTemplateUIReducer.readOnly,
    accountTimezone: state.internalReducer.internal.accountTimezone,
  };
};

const mapDispatchToProps = {
  setReadOnly,
};

ViewFormTemplateVersionContainer.propTypes = {
  formTemplateRequestLoading: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  setReadOnly: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewFormTemplateVersionContainer);
